import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@mui/material";

const ClientRecceHoldOnModal = ({ open, onClose, onSubmit }) => {
  const [holdOnReason, setHoldOnReason] = useState("");

  const handleSubmit = () => {
    onSubmit(holdOnReason);
    setHoldOnReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <label className="my-2">Hold On Reason (Optional):</label>
        <TextField
          autoFocus
          margin="dense"
          label="Enter Reason"
          type="text"
          fullWidth
          value={holdOnReason}
          onChange={(e) => setHoldOnReason(e.target.value)}
          placeholder="Optional - you can leave this empty"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {`Close`}
        </Button>
        <Button onClick={handleSubmit} color="warning">
          {`Hold On`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientRecceHoldOnModal;
